import Vue from 'vue';
import { NoticeBar } from 'vant';
import 'vant/lib/index.css';
import '@assets/scss/officialTopupNew/font/icon.js';

if (window.hwerrVue) {
  Vue.config.errorHandler = window.hwerrVue;
}

import { initBiPoint, initBatchBiPoint } from '../../resource/plugins/biPoint/index';
import { UPLOAD_TYPE } from '../../resource/plugins/biPoint/define';

import App from '../../officialTopupNewApp.vue';
import router from '../rooters/officialTopupNew';
import store from '../stores/officialTopupNew';
import commonComponents from '@components/officialTopupNew/common/commonComponents';
import clickThrottling from '../../resource/plugins/clickThrottling';
import 'swiper/css/swiper.css';
import { handleStoreDefaultCid } from '@utiles/storeHandleCid';
import '@plugins/replaceAllPolyfills';
import globalConfig from '@utiles/officialStore/globalConfig';
import bridge from '@utiles/bridge';

// ！！！注意：重定向逻辑要在initBiPoint之前，否则会导致【会话开始】打点打在旧页面.
// 重定向逻辑 start
const gameId =
  globalConfig.getHrefParam('gameId') ||
  globalConfig.getHrefParam('gameID') ||
  globalConfig.getHrefParam('game_id') ||
  '';

// 2025.7.8 ROV跳转ROG V3第三方支付页
if ([371].includes(+gameId)) {
  const currentUrl = new URL(window.location);
  currentUrl.searchParams.set('gameId', 426);
  if (bridge.runInsdk()) {
    bridge.callSdkMethod('openWebView', {
      url: currentUrl.href,
      loginDir: 0,
      appendParams: 1,
      pageOrientation: 1
    });
  } else {
    window.location.href = currentUrl.href;
  }
}

handleStoreDefaultCid();
// 排除 gameId=371(ROV)：该游戏会重定向到 426(ROG)，不在此页初始化打点
if (![371].includes(+gameId)) {
  initBiPoint({ dataLayerName: 'webstorev35DataLayer' });
  
  // 新方案：批量上报（测试方案）
  const BATCH_SIZE = 3; // 每 N 条打点批量上报
  const MAX_WAIT_TIME_MS = 2000; // 最长等待时间（毫秒）
  const RETRY_TIMES = 3; // 失败重试次数
  const batchListener = initBatchBiPoint({
    dataLayerName: 'webstorev35DataLayerBatch', // 使用独立的dataLayer名称
    uploadType: UPLOAD_TYPE.webstorev35,
    needInitCommonParams: false, // 公共参数已在旧方案初始化
    sendSessionEnd: false, // 会话管理由旧方案处理
    batchConfig: {
      batchSize: BATCH_SIZE,
      maxWaitTime: MAX_WAIT_TIME_MS,
      retryTimes: RETRY_TIMES,
      monitor: {
        enabled: true // 启用监控
      }
    }
  });
}

Vue.use(NoticeBar);

// 设置点击节流.
Vue.use(clickThrottling);
clickThrottling.setThrottlingTime(300);

Vue.config.productionTip = true;
Vue.use(commonComponents);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#officialTopupNew');
